package com.tregz.tremenz.io.model

import kotlin.js.Date

actual fun currentLocalHour(): Int = Date().getHours()
